export default __webpack_public_path__ + "static/media/serviceNegative.d0c975e5.webp";